module.exports = __webpack_public_path__ + "static/media/Orbitron.f7c414c7.woff";